import * as React from 'react';

var _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgBuild = function SvgBuild(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_247_25591)",
        fillOpacity: 0.16,
        d: "M67.92 74a6.2 6.2 0 0 1-2.236-.407q-1.057-.406-1.967-1.288l-21.587-21.7a32 32 0 0 1-4.289 1.497q-2.15.582-4.585.581-8.023 0-13.64-5.613Q14 41.456 14 33.437q0-2.07.44-4.072a18.6 18.6 0 0 1 1.29-3.842l12.555 12.336 9.688-9.418-12.431-12.555a22.4 22.4 0 0 1 3.77-1.373A15.5 15.5 0 0 1 33.287 14q8.136 0 13.83 5.668 5.696 5.667 5.696 13.763 0 2.55-.547 4.695a21.4 21.4 0 0 1-1.533 4.152l21.503 21.45a6.7 6.7 0 0 1 1.324 2.03Q74 66.84 74 68.04a6.1 6.1 0 0 1-.451 2.346 5.5 5.5 0 0 1-1.4 1.967q-.927.855-1.988 1.25a6.4 6.4 0 0 1-2.24.397"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_247_25591)",
        d: "M63.92 70a6.2 6.2 0 0 1-2.236-.407q-1.057-.406-1.967-1.288l-21.587-21.7a32 32 0 0 1-4.289 1.497q-2.15.582-4.585.581-8.023 0-13.64-5.613Q10 37.456 10 29.437q0-2.07.44-4.072a18.6 18.6 0 0 1 1.29-3.842l12.555 12.336 9.688-9.418-12.431-12.555a22.4 22.4 0 0 1 3.77-1.373A15.5 15.5 0 0 1 29.287 10q8.136 0 13.83 5.668 5.696 5.667 5.696 13.763 0 2.55-.547 4.695a21.4 21.4 0 0 1-1.533 4.152l21.503 21.45a6.7 6.7 0 0 1 1.324 2.03Q70 62.84 70 64.04a6.1 6.1 0 0 1-.451 2.346 5.5 5.5 0 0 1-1.4 1.967q-.927.855-1.988 1.25a6.4 6.4 0 0 1-2.24.397m-2.294-3.718q.986.984 2.36.984 1.375 0 2.292-.916.985-.984.985-2.358 0-1.372-.985-2.29l-22.98-22.956a15.8 15.8 0 0 0 2.066-4.432q.711-2.43.711-4.877 0-7.074-5.757-12.514t-14.193-4.162l10.01 10.04q.663.657.732 1.644t-.596 1.65l-10.303 9.992q-.658.595-1.714.595t-1.652-.595l-9.859-9.828q-1.032 9.438 4.481 14.565 5.514 5.125 12.062 5.125 2.338 0 4.771-.676a14.2 14.2 0 0 0 4.438-2.098z"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_247_25591",
        x1: 14.627,
        x2: 73.165,
        y1: 44,
        y2: 44,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_247_25591",
        x1: 10.627,
        x2: 69.165,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgBuild as ReactComponent };
//# sourceMappingURL=Build.svg.es.js.map
